import { Directive, OnInit } from "@angular/core";
import { NbMenuItem, NbMenuService } from "@nebular/theme";
import { EditorService } from "./services/editor.service";
import { DynamicInputComponent, MenuGroup } from "./dynamic-input-model";

@Directive({
    selector: '[ngxBaseEditor]'
})

export abstract class BaseEditor implements OnInit{
    menuGroups:any;
    inputComponent:DynamicInputComponent;
    menuGroup:MenuGroup;
    menuItems:NbMenuItem[];
    previousMenu:NbMenuItem[];
    title:string;

    constructor(
        protected editorService:EditorService,
        protected menuService:NbMenuService) { }

    ngOnInit(): void {
        this.menuGroups = this.editorService.createMenusFromGroup(this.menuGroup);
        this.inputComponent.data = this.menuGroups;
        this.editorService.setInputComponent(this.inputComponent);
        console.log(this.menuGroups);
        this.menuService.onItemClick().subscribe(menuBag =>{
        let selectedItem = menuBag.item;
        if(selectedItem != undefined){
            this.setMenu(selectedItem);
        }
        });
    }

    setMenu(selectedItem:NbMenuItem){
        if(selectedItem.title == "Back"){
          this.menuItems = this.previousMenu;
        }else{
          this.menuGroup.menuItems.forEach(menuItem => {
            if(menuItem.title == selectedItem.title && menuItem.children != null){
              this.previousMenu = this.menuItems;
              console.log(menuItem.title);
              let backLinkLNbMenuItem = {title:"Back",icon:"arrow-back-outline"};
              let headerItem:NbMenuItem = {title:menuItem.title,group:true}
              this.menuItems = [backLinkLNbMenuItem,headerItem].concat(menuItem.children);
            }
          })
        }
        
      }
}